import {RecodeLogic, Win} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {GameRecodeSpinResult} from 'src/logic/recode/GameRecodeSpinResult';
import {SpinResult} from '@fantasmagames/slot/src/logic/SpinResult';
import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {AvalancheResult, PrototypeWinLine} from '@fantasmagames/slot/src/logic/prototype/PrototypeSpinResult';
import {GameSymbol} from '@fantasmagames/slot/src/modules/reels/data/GameSymbol';
import {Logic} from '@fantasmagames/slot/src/logic/Logic';
import {GamePrototypeLogic} from 'src/logic/prototype/GamePrototypeLogic';
import {IEventManagerWithAsync} from '@fantasmagames/core/src/events/_interfaces/IEventManager';
import {RecodeIntegrator} from '@fantasmagames/slot/src/integration/RecodeIntegrator';
import {Device} from '@fantasmagames/core/src/device/Device';
import {RecodeToPrototypeConverter} from 'src/logic/recode/RecodeToPrototypeConverter';
import {Action} from '@fantasmagames/slot/src/logic/Action';

export class GameRecodeLogic extends RecodeLogic {
	// Override for this Riviera star which does not use symbolheights.
	protected get _reelsHeight(): number[][] {
		return [[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]];
	}

	protected setResultsForCurrentRound(): void {
		if (this._currentRound > 0 && this._reels[this._currentRound - 1]) {
			this.getRecodeSpinResults().setPreviousReels(this._reels[this._currentRound - 1], this._reelsHeight[0]);
		}

		this.getRecodeSpinResults().setWaysToWin(this._waysRounds[0]); // It is the same for all rounds in this Medallion.
		// this.getRecodeSpinResults().setWaysToWin(this._waysRounds[this._currentRound]);
		this.getRecodeSpinResults().setReels(this._reels[this._currentRound], this._reelsHeight[0]);
		const wins: Win[] = this.getWinsFromRound(this._currentRound);
		this.getRecodeSpinResults().setWins(wins);
		this.getRecodeSpinResults().setRoundWin(this.getWinsSum(this.getWinsFromRound(this._currentRound)));
		this.getRecodeSpinResults().setNextRoundWin(this.getWinsSum(this.getWinsFromRound(this._currentRound + 1)));
		this.getRecodeSpinResults().setTotalWin(this._totalWin);

		/*	if (wins && wins.length > 0 && this.isFreeSpinsStarted) {
			this._freeSpinsMultiplier = wins[0].multiplier + 1;
		}*/

		this.setNextAction();
		// TODO: change current round values here
	}

	protected setInitResults(): void {
		if (this.isFreeSpinsStarted) {
			this.getRecodeSpinResults().setReels(this._reels[this._reels.length - 1], this._reelsHeight[0]);
		} else {
			this.getRecodeSpinResults().setReels(this._reels[this._currentRound], this._reelsHeight[0]);
		}
		this.setNextAction();

		// if (this.getNextRoundType() === RoundTypes.BONUS) {
		// 	this.makeNextBonusSymbolsList();
		// }
		if (this.freeSpinsLeft > 0) {
			// this.makeNextFreespin!
		}
	}

	protected _realLogic: GamePrototypeLogic;
	protected _freeSpinsTriggerReels: number[];
	protected _freeSpinsTriggerSymbols: GameSymbol[][];

	constructor(gameName: string, eventManager: IEventManagerWithAsync, communicator: RecodeIntegrator, device: Device) {
		super(gameName, eventManager, communicator, device);

		this._realLogic = new GamePrototypeLogic(gameName, eventManager, communicator, device);
	}

	protected parseSlot(data: any): void {
		super.parseSlot(data);

		if (this._freeSpinsLeft === 0) {
			this.parseFreeSpinTriggerSets(data);
		}
	}

	public updateFreeSpinsTriggerSymbols(symbols: string[][]): void {
		this._freeSpinsTriggerSymbols = [];
		let reelIndex: number = 0;
		for (const reel of symbols) {
			this._freeSpinsTriggerSymbols.push([]);
			let rowIndex: number = 0;
			for (const sym of reel) {
				this._freeSpinsTriggerSymbols[reelIndex]
					.push(new GameSymbol(RecodeToPrototypeConverter.gameSymbolNameToId(sym),
					{width: 1, height: 1},
					{x: reelIndex, y: rowIndex}));
				rowIndex++;
			}
			reelIndex++;
		}
	}

	protected parseFreeSpinTriggerSets(data: any): void {
		this._freeSpinsTriggerReels = [];

		const results: any[] = data.ResultSets.Result;
		const baseName = 'BaseGame';

		for (const res of results) {
			const name: string = res.attributes.name;

			if (name.includes(baseName)) {
				if (!res.Reels) {
					continue;
				}

				if (!res.Reels.length) {
					res.Reels = [res.Reels];
				}

				const lastReel = res.Reels[res.Reels.length - 1];
				const reelSymbols: string[] = lastReel.attributes.symbols.split(',');
				for (const sym of reelSymbols) {
					this._freeSpinsTriggerReels.push(Number.parseInt(sym, 10));
				}
			}
		}
	}

	public init(cb: Function): void {
		super.init( (data: any) => {
			this._realLogic.reactOnInit(RecodeToPrototypeConverter.convertInit(data, this));
			cb && cb(data);
		});
	}

	public spin(cb: Function): void {
		super.spin( (data: any) => {
			this._realLogic.reactOnSpin(RecodeToPrototypeConverter.convertSpin(data, this));
			cb && cb(data);
		});
	}

	public freespin(cb: Function): void {
		super.freespin( (data: any) => {
			this._realLogic.reactOnFreeSpin(RecodeToPrototypeConverter.convertSpin(data, this));
			cb && cb(data);
		});
	}

	protected createSpinResult(): SpinResult {
		return new GameRecodeSpinResult();
	}

	public startNextRound(): void {
		super.startNextRound();

		this._realLogic.startNextRound();
	}

	public hasWinsToHighlight(): boolean {
		return this._realLogic.hasWinsToHighlight();
	}

	public getAllWinningSymbolsFromCurrentRound(): SymbolPosition[] {
		return this._realLogic.getAllWinningSymbolsFromCurrentRound();
	}

	public getAllWinLinesFromCurrentRound(): PrototypeWinLine[] {
		return this._realLogic.getAllWinLinesFromCurrentRound();
	}

	public getCurrentReelsSymbol(pos: SymbolPosition): GameSymbol {
		return this._realLogic.getCurrentReelsSymbol(pos);
	}

	public getCurrentRoundWinningWilds(): SymbolPosition[] {

		return this._realLogic.getCurrentRoundWinningWilds();

	}

	public getCurrentRoundTotalWinNoMultiplier(): number {
		return this._realLogic.getCurrentRoundTotalWinNoMultiplier();
	}

	public getLastAvalancheRunningTotal(): number {
		return this._realLogic.getLastAvalancheRunningTotal() / Logic.CENT_TO_A_DOLLAR;
	}

	public getLastAvalancheMultiplier(): number {
		return this._realLogic.getLastAvalancheMultiplier();
	}

	public getNextAvalancheRunningTotalInCents(): number {

		return this._realLogic.getNextAvalancheRunningTotalInCents();
	}

	public get currentSpinWin(): number {
		return this._realLogic.currentSpinWin;
	}

	public getFinalSymbolsPosition(): AvalancheResult {
		return this._realLogic.getFinalSymbolsPosition();
	}

	public isFreeSpinsTrigger(): boolean {
		return this._realLogic.isFreeSpinsTrigger();
	}

	protected tempInitSymbolSizes(): void {

	}

	public get nextAction(): Action {
		return this._realLogic.nextAction;
	}

	public getSpinResult(): SpinResult {
		return this._realLogic.getSpinResult();
	}

	public finishFreeSpins(): void {
		super.finishFreeSpins();
		this._realLogic.forceSetNextAction(Action.SPIN);
	}

	public startFreeSpinsIntro(): void {
		super.startFreeSpinsIntro();
		this._realLogic.forceSetNextAction(Action.FREESPIN);

	}

	public goIntoFreeSpins(): void {
		this._realLogic.forceSetIsInFreeSpins(true);
	}

	public goOutOfFreeSpin(): void {
		this._realLogic.forceSetIsInFreeSpins(false);
	}

	public get freeSpinsTriggerReels(): number[] {
		return this._freeSpinsTriggerReels;
	}

	public get freeSpinsTriggerSymbols(): GameSymbol[][] {
		return this._freeSpinsTriggerSymbols;
	}

	public get hasFreeSpinsRetrigger(): boolean {
		return this._realLogic.hasFreeSpinsRetrigger;
	}

	public get freeSpinsAdded(): number {
		return this._realLogic.freeSpinsAdded;
	}
}



// WEBPACK FOOTER //
// ./src/logic/recode/GameRecodeLogic.ts